/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatePublicOrderCommand = {
    /**
     * Payment type. Bank card or Invoice.
     */
    paymentType: CreatePublicOrderCommand.paymentType;
    /**
     * Customer first name
     */
    customerFirstName: string;
    /**
     * Customer last name
     */
    customerLastName: string;
    /**
     * Customer email
     */
    customerEmail: string;
    /**
     * Redirect URL
     */
    redirectUrl?: string;
    /**
     * Offense variable symbol
     */
    offenseVariableSymbol?: string;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
};
export namespace CreatePublicOrderCommand {
    /**
     * Payment type. Bank card or Invoice.
     */
    export enum paymentType {
        CASH = 'CASH',
        BANK_CARD = 'BANK_CARD',
        ELECTRONIC_WALLET = 'ELECTRONIC_WALLET',
        INVOICE = 'INVOICE',
    }
}

